<template>
  <div class="expertThinkTank">
    <comHead :tabIndexI="8" :imgSrc="imgSrc" />
    <div class="contactbg">
      <ul class="contactCenter">
        <li class="column">
          <div class="photo">
            <img src="../../static/imgs/concatUs/icon1.png" alt="" />
          </div>
          <div>
            <h1>服务热线</h1>
            <p>400-6811-508</p>
          </div>
        </li>
        <li class="shuxian"></li>
        <li class="column">
          <div class="photo">
            <img src="../../static/imgs/concatUs/icon2.png" alt="" />
          </div>
          <div>
            <h1>官方网站</h1>
            <p>www.dhipr.com</p>
          </div>
        </li>
        <li class="shuxian"></li>
        <li class="column">
          <div class="photo">
            <img src="../../static/imgs/concatUs/icon3.png" alt="" />
          </div>
          <div>
            <h1>联系邮箱</h1>
            <p>dh@dhipr.com</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="addressbg">
      <div class="addressCenter">
        <h1>鼎宏集团 服务全国</h1>
        <h2>更多城市正在筹建中，敬请期待！</h2>
        <ul class="locationCenter">
          <li class="location beijing">
            <h3>鼎宏·北京</h3>
            <!-- <h4>地址:北京市西城区西直门外大街金贸大厦A座22层</h4>
            <p>电话: 010-63353508</p> -->
          </li>
          <li class="location chegndu">
            <h3>鼎宏·四川</h3>
            <!-- <h4>地址:成都市锦江区东大街芷泉段68号时代8号12层</h4>
            <p>电话: 028-69889999</p> -->
          </li>
          <li class="location yunnan">
            <h3>鼎宏·云南</h3>
            <!-- <h4>
              地址:云南省昆明市五华区高新区科高路1612号火炬大厦2层、3层、M层
            </h4>
            <p>电话: 0871-63121792</p> -->
          </li>
        </ul>
        <ul class="locationCenter">
          <li class="location henan">
            <h3>鼎宏·河南</h3>
            <!-- <h4>地址:河南省郑州市金水区花园路144号信息大厦16层</h4>
            <p>电话: 0371-89816882</p>
            <h4>地址:河南省郑州市郑东新区商务外环路25号王鼎国际大厦16层</h4>
            <p>电话: 0371-89816883</p> -->
          </li>
          <li class="location guizhou">
            <h3>鼎宏·贵州</h3>
            <!-- <h4>地址:贵州省贵阳市南明区市南路42号保利国际广场6栋12层</h4>
            <p>电话: 0851-88250197</p> -->
          </li>
          <li class="location shaxi">
            <h3>鼎宏·陕西</h3>
            <!-- <h4>
              地址:陕西省西安市高新区丈八街办锦业路与丈八一路东北角旺都B栋15层
            </h4>
            <p>电话: 029-87998166</p> -->
          </li>
        </ul>
        <ul class="locationCenter">
          <li class="location chongqin">
            <h3>鼎宏·重庆</h3>
            <!-- <h4>地址:重庆市江北区桥北苑2号2幢蓝洋金融中心14层</h4>
            <p>电话: 023-62899683</p> -->
          </li>
          <li class="location xizang">
            <h3>鼎宏·西藏</h3>
            <!-- <h4>地址:西藏拉萨市柳梧新区海亮颇章19幢106号</h4>
            <p>电话: 028-69889999</p> -->
          </li>
          <li class="location qinghai">
            <h3>鼎宏·青海</h3>
            <!-- <h4>地址:青海省西宁市城西区西川南路76号76-34号</h4>
            <p>电话: 028-69889999</p> -->
          </li>
        </ul>
      </div>
    </div>
    <comFooter />
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgSrc: require("../../static/imgs/concatUs/banner.jpg"),
    };
  },

  methods: {},
  props: {
    tabIndexI: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/style/index.scss";

/deep/ .el-menu--horizontal>.other {
  border-bottom: 2px solid #fff !important;
}


.expertThinkTank {
  background: #fff !important;
  .contactbg {
    background: #f7f7f7 !important;
    .contactCenter {
      max-width: 1200px;
      margin: 0 auto;
      padding: 30px 0;
      display: flex;
      align-items: center;
      .shuxian {
        height: 30px;
        width: 1px;
        background-color: #d6d6d6;
      }
      .column {
        display: flex;
        align-items: center;
        padding: 0 94px;

        .photo {
          margin-right: 16px;
        }
        h1 {
          font-size: 16px;
          color: #666;
        }
        p {
          font-size: 20px;
          color: #333;
        }
      }
    }
  }
  .addressbg {
    background: #fff !important;
    .addressCenter {
      max-width: 1200px;
      margin: 0 auto;
      padding: 50px 0 60px 0;
      h1 {
        font-size: 36px;
        color: #333;
        text-align: center;
         margin-bottom: 10px;
      }
      h2 {
        font-size: 14px;
        color: #999;
        text-align: center;
        margin-bottom: 50px;
      }
      .locationCenter {
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-bottom: 30px;
        .location{
          background: url(../../static/imgs/concatUs/bj.jpg) no-repeat bottom
            left;
          width: 32%;
          height: 200px;
          box-shadow: 3.507px 7.19px 15.52px 0.48px rgba(30, 80, 150, 0.07);
          padding: 20px 20px 0 20px;
          margin-right: 30px;
          cursor: pointer;
          h3 {
            font-size: 38px;
            color: #333;
            margin-bottom: 10px;
            font-weight: bold;
            text-align:center;
            margin: 50px 0 50px 0;
          }
          h4,
          p {
            font-size: 14px;
            color: #666;
            margin-bottom: 6px;
          }
        }
        .location:hover {
          transition: all 0.8s ease-out;
          -webkit-transition: all 0.8s ease;
          -moz-transition: all 0.8s ease;
          -ms-transition: all 0.8s ease;
          -o-transition: all 0.8s ease;
          h3 {
            color: #333;
          }
          h4,
          p,
          h3 {
            color: #fff;
          }
        }
        .beijing:hover{
           background: url(../../static/imgs/concatUs/bj.jpg) no-repeat top right;
        }
        .chegndu:hover{
          background: url(../../static/imgs/concatUs/cd.jpg) no-repeat top right;
        }
        .yunnan:hover{
          background: url(../../static/imgs/concatUs/yn.jpg) no-repeat top right;
        }
        .henan:hover{
          background: url(../../static/imgs/concatUs/hn.jpg) no-repeat top right;
        }
        .guizhou:hover{
          background: url(../../static/imgs/concatUs/gz.jpg) no-repeat top right;
        }
        .shaxi:hover{
          background: url(../../static/imgs/concatUs/sx.jpg) no-repeat top right;
        }
        .chongqin:hover{
          background: url(../../static/imgs/concatUs/cq.jpg) no-repeat top right;
        }
        .xizang:hover{
          background: url(../../static/imgs/concatUs/xz.jpg) no-repeat top right;
        }
         .qinghai:hover{
          background: url(../../static/imgs/concatUs/qh.jpg) no-repeat top right;
        }
        .locationCenter:last-child {
          margin-right: 0 !important;
        }
      }
    }
  }
}
@media screen and(max-width: 500px) {
	.expertThinkTank{
		.contactbg{
			.contactCenter{
				display:grid;
				margin: 0 10px;
			}
		}
		.addressbg{
			.addressCenter{
				min-width: auto;
				.locationCenter{
					display:grid;
					.location{
						width: 100vw;
						margin-right: 0px;
						padding: 10px 5px;
						margin: 0 auto;
					}
				}
			}
		}
	}
}
</style>